import {
  Card,
  CardBody,
  CardFooter,
  CardHeader,
} from "../../../components/card/card";
import ImageViewer from "../../../components/ImageViewer";
import { printDate, printLocation } from "../../../utils/helper";
import React, { useState, useEffect } from "react";
import { user as userAPI, team, location, asset } from "../../../api";
import { parserAPI } from "../../../utils/parser";
import { useQuery } from "@tanstack/react-query";
import DataTable from "react-data-table-component";
import { toast } from "react-toastify";
import NormalInput from "../../../components/form/HorizontalNormalInput";

import ConfirmationDlg from "../../../components/ConfirmationDlg";
import Select, { StylesConfig } from "react-select";
import { PermissionChecker } from "../../../components/PermissionChecker";
import { isPermissionAllowed } from "../../../components/PermissionChecker/permissionChecker";
import { useAuth } from "../../../contexts/AuthContext";
import { useDashboardContext } from "../../../contexts/NewDashboardContext";
import DebounceInput from "../../../components/form/HorizontalDebounceInput";

const colourStyles = {
  control: (styles) => ({
    ...styles,
    backgroundColor: "rgba(0, 0, 0, 0.48)",
    borderColor: "var(--bs-border-color)",
  }),
  input: (styles) => ({
    ...styles,
    color: "white",
  }),
  menu: (styles) => ({
    ...styles,
    color: "grey",
  }),
};

function getLeafLocationsWithPath(locations) {
  const result = [];

  function traverse(location, path) {
    const currentPath = [...path, location.location_name];

    if (!location.sublocations || location.sublocations.length === 0) {
      result.push({
        value: location.id,
        label: currentPath.join(" | "),
      });
    } else {
      location.sublocations.forEach((sublocation) =>
        traverse(sublocation, currentPath)
      );
    }
  }

  locations.forEach((location) => traverse(location, []));

  return result;
}

function TeamConfiguration() {
  const [openDetail, setOpenDetail] = useState(false);
  const [isDirty, setIsDirty] = useState(false);
  const [confirmDlg, setConfirmDlg] = useState(false);
  const [openModalTeam, setOpenModalTeam] = useState(false);
  const [teamName, setTeamName] = useState("");
  const [member, setMember] = useState([]);
  const [users, setUsers] = useState([]);
  const [locations, setLocations] = useState([]);
  const [assets, setAssets] = useState([]);
  const [teams, setTeams] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [deleteRow, setDeleteRow] = useState(null);
  const [query, setQuery] = useState({
    page: 1,
    take: 10,
    totalData: 1,
    keyword: "",
  });
  const [loading, setLoading] = useState(false);
  const [selectedLocations, setSelectedLocations] = useState([]);
  const [selectedAsset, setSelectedAsset] = useState([]);
  const [filteredAssets, setFilteredAssets] = useState([]);
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const { allowedPermissions } = useAuth();
  const { selectedApp } = useDashboardContext();
  async function getUser() {
    try {
      const res = await userAPI.list();
      if (res.ok) {
        const body = await res.json();
        let data = body.data;
        if (data.length) {
          let tmp = [];
          data.map((i, index) => {
            let item = i;
            item.id = index + 1;
            tmp.push(item);
          });
          setUsers(tmp);
          setIsDirty(false);
        }
      }
    } catch (e) {
      toast.error(e.message);
      console.error(e);
    }
  }

  async function getTeam() {
    try {
      setLoading(true);
      const res = await team.list(query);
      if (res.ok) {
        const body = await res.json();
        let data = body.data;
        if (data.results) {
          setTeams(data.results);
          setIsDirty(false);
        } else {
          setTeams([]);
          setIsDirty(false);
        }

        if (data.totalData) {
          setQuery((prev) => ({
            ...prev,
            totalData: data.totalData,
          }));
        }
        setLoading(false);
      }
    } catch (e) {
      toast.error(e.message);
      console.error(e);
    }
  }

  async function getLocation() {
    const res = await location.list("", "true");
    if (res.ok) {
      const body = await res.json();
      const data = body.data;
      setLocations(data);
    }
  }

  async function getAsset() {
    const res = await asset.list();
    if (res.ok) {
      const body = await res.json();
      const data = body.data;
      setAssets(
        data.map((i) => ({
          value: i.id,
          label: i.asset_name,
          location_id: i.location_id,
        }))
      );
    }
  }

  useEffect(() => {
    getTeam();
  }, [query.page, query.take, isDirty, query.keyword]);

  useEffect(() => {
    getUser();
    getLocation();
    // getAsset();
  }, []);

  function selectUser(value) {
    //console.log("selected machine", value);
  }
  function addUser(value) {
    setSelectedRow(null);
    setOpenModalTeam(true);
    setTeamName("");
    setMember([]);
    setSelectedLocations([]);
    setSelectedAsset([]);
    setFilteredAssets([]);
  }
  function editUser(value) {
    setSelectedRow(value);
    setOpenModalTeam(true);
    setTeamName(value.team_name);
    setMember(
      value.members.map((member) => ({
        value: member.member.username,
        label: member.member.firstname + " " + member.member.lastname,
      }))
    );
    setSelectedLocations(
      value.assigned_locations.map((location) => location.location_id)
    );
  }

  function showConfirmationDlg(row) {
    setDeleteRow(row);
    setConfirmDlg(true);
  }
  function hideConfirmationDialog() {
    setDeleteRow(null);
    setConfirmDlg(false);
  }

  async function deleteUser() {
    try {
      const res = await team.delete(deleteRow.id);
      if (res.ok) {
        toast.success("This team has been deleted");
        setConfirmDlg(false);
        setDeleteRow(null);
        const body = await res.json();
        setIsDirty(true);
        await getTeam();
      }
    } catch (e) {
      toast.error(e.message);
      console.error(e);
    }
  }
  const columns = [
    {
      name: "Team Name",
      selector: (row) => row.team_name,
    },
    {
      name: "Total Member",
      minWidth: "200px",
      style: {
        paddingRight: "0",
      },
      cell: (row) => {
        return <span>{row.members?.length}</span>;
      },
    },
    {
      name: "Action",
      width: "150px",
      style: {
        paddingRight: "0",
      },
      cell: (row) => {
        return (
          <div>
            <PermissionChecker permissions={["edit team"]} hideIfNotAllowed>
              <button
                onClick={() => {
                  editUser(row);
                }}
                className="btn btn-sm btn-outline-theme mx-1"
              >
                <i className="fa fa-edit"></i>
              </button>
            </PermissionChecker>
            <PermissionChecker permissions={["delete team"]} hideIfNotAllowed>
              <button
                onClick={() => {
                  showConfirmationDlg(row);
                }}
                className="btn btn-sm btn-outline-danger"
              >
                <i className="fa fa-trash"></i>
              </button>
            </PermissionChecker>
          </div>
        );
      },
    },
  ];

  async function onSubmitTeam() {
    setLoadingSubmit(true);
    let data = {
      team_name: teamName,
      members: member.map((i) => i.value),
      locations: [...selectedLocations],
      assets: [],
    };
    console.log({ data });
    if (!selectedRow) {
      const response = await team.create2(data);
      if (response.ok) {
        const body = await response.json();
        //console.log({ body });
        if (body.success) {
          //toast.success(body.message);
          toast.success("Team " + teamName + " is successfully added");
          setSelectedRow(null);
          setOpenModalTeam(false);
          setIsDirty(true);
          await getTeam();
        } else {
          toast.error(body.message);
        }
      } else {
        toast.error("API Error");
      }
    } else {
      const response = await team.update(selectedRow.id, data);
      if (response.ok) {
        const body = await response.json();
        //console.log({ body });
        if (body.success) {
          //toast.success(body.message);
          toast.success("Team " + teamName + " is successfully updated");
          setSelectedRow(null);
          setOpenModalTeam(false);
          setIsDirty(true);
          await getTeam();
        } else {
          toast.error(body.message);
        }
      } else {
        toast.error("API Error");
      }
    }
    setLoadingSubmit(false);
  }

  const handleSelectLocation = (id) => {
    if (selectedLocations.includes(id)) {
      setSelectedLocations((values) => values.filter((v) => v !== id));
    } else {
      setSelectedLocations((values) => [...values, id]);
    }
  };

  const isSelectedLocation = (id) => {
    return selectedLocations.includes(id);
  };
  let level = 0;
  const renderLocations = (locations, level) => {
    level++;
    return (
      <>
        {locations.map((location, index) => {
          return (
            <div key={index}>
              <div
                className="form-check"
                onClick={() => handleSelectLocation(location.id)}
              >
                <input
                  className="form-check-input"
                  checked={isSelectedLocation(location.id)}
                  type="checkbox"
                  id={`${location.id}`}
                />
                <label className="form-check-label" htmlFor={location.id}>
                  {location.location_name}
                </label>
              </div>
              {level < 3 &&
                location.sublocations &&
                location.sublocations.length > 0 && (
                  <div style={{ marginLeft: "20px" }}>
                    {renderLocations(location.sublocations)}
                  </div>
                )}
            </div>
          );
        })}
      </>
    );
  };

  return (
    <div>
      <ConfirmationDlg
        loading={loadingSubmit}
        open={openModalTeam}
        onSubmit={onSubmitTeam}
        btnSubmitText={"Save"}
        title={"Add Team"}
        btnCancelText={"Cancel"}
        onClose={() => {
          setOpenModalTeam(false);
        }}
        hideSubmitBtn={
          !isPermissionAllowed(allowedPermissions, selectedApp, ["edit team"])
        }
      >
        <NormalInput
          required={true}
          value={teamName}
          type={"text"}
          label="Team Name"
          onchange={(e) => {
            setTeamName(e.target.value);
          }}
          name="teamName"
        />
        <div className="mb-3 force-transparent" style={{ zIndex: 9999999 }}>
          <label className="form-label">Member</label>
          <Select
            isMulti
            styles={{
              ...colourStyles,
              menu: (styles) => ({
                ...styles,
                zIndex: 9999,
                position: "absolute",
                color: "grey",
              }),
              menuPortal: (styles) => ({
                ...styles,
                zIndex: 9999,
              }),
            }}
            options={users.map((i) => {
              return {
                value: i.username,
                label: i.firstname + " " + i.lastname,
              };
            })}
            value={member}
            onChange={(e) => {
              setMember(e);
            }}
            menuPortalTarget={document.body}
            menuPosition="fixed"
          />
        </div>

        <Card>
          <CardHeader>Assigned Work Order Locations</CardHeader>
          <CardBody>
            <div>{renderLocations(locations, level)}</div>
          </CardBody>
        </Card>
      </ConfirmationDlg>
      <ConfirmationDlg
        open={confirmDlg}
        onClose={() => {
          setConfirmDlg(false);
          setDeleteRow(null);
        }}
        onSubmit={deleteUser}
      >
        <div>Are you sure you want to delete this Team?</div>
      </ConfirmationDlg>
      <div className="d-flex align-items-center mb-3">
        <div>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="#/">Configuration</a>
            </li>
            <li className="breadcrumb-item active">Teams</li>
          </ol>
          <h1 className="page-header mb-0">Teams</h1>
        </div>
      </div>

      <div className="row gx-4">
        <div className="col-lg-12 ">
          <div className="row justify-content-end">
            <div className="col-sm-3 mb-2 mb-sm-0">
              <DebounceInput
                placeholder="Search Team.."
                debounceTimeout={1000}
                value={query.keyword}
                showDebounceIndicator
                name="keyword"
                onchange={(e) => {
                  setQuery((prev) => ({
                    ...prev,
                    keyword: e.target.value,
                    page: 1,
                  }));
                }}
              />
            </div>
            <div className="col-sm-3 mb-2 mb-sm-0">
              <PermissionChecker permissions={["create team"]} hideIfNotAllowed>
                <button
                  onClick={addUser}
                  className="btn btn-outline-theme w-100"
                >
                  Add Team <i className="bi bi-plus"></i>
                </button>
              </PermissionChecker>
            </div>
          </div>
          <Card className="mb-4 mt-2">
            <CardHeader>List Teams</CardHeader>
            <CardBody>
              <DataTable
                progressPending={loading}
                pointerOnHover
                onRowClicked={(row) => {
                  editUser(row);
                }}
                highlightOnHover
                theme="dark"
                columns={columns}
                data={teams}
                pagination
                paginationServer
                onChangeRowsPerPage={(row) =>
                  setQuery((prev) => ({ ...prev, page: 1, take: row }))
                }
                paginationTotalRows={query.totalData}
                onChangePage={(page) =>
                  setQuery((prev) => ({ ...prev, page: page }))
                }
                paginationDefaultPage={query.page}
              />
            </CardBody>
          </Card>
        </div>
      </div>
    </div>
  );
}
export default TeamConfiguration;
